import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  DeleteStudentScholarshipData,
  StudentScholarshipData,
  UpdateStudentScholarshipData,
} from '../models/student-scholarship-data.model';
import { ScholarshipType, ScholarshipTypeMap } from '../models/scholarship-type.model';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScholarshipService {

  private apiUrl = `${environment.sgcApi}`;
  private scholarshipRoute = 'scholarship';

  constructor(
    private httpClient: HttpClient
  ) {}

  addStudentScholarship(
    studentScholarshipData: StudentScholarshipData,
    user: string
  ) {
    const endpointUrl = `${this.apiUrl}${this.scholarshipRoute}/user/${user}/student`;
    return this.httpClient.post<number>(
      endpointUrl,
      JSON.stringify(studentScholarshipData)
    );
  }

  editStudentScholarship(
    updateStudentScholarshipData: UpdateStudentScholarshipData,
    user: string
  ) {
    const endpointUrl = `${this.apiUrl}${this.scholarshipRoute}/user/${user}/student`;
    return this.httpClient.put(
      endpointUrl,
      JSON.stringify(updateStudentScholarshipData)
    );
  }

  deleteStudentScholarship(
    deleteStudentScholarshipData: DeleteStudentScholarshipData,
    user: string
  ) {
    const endpointUrl = `${this.apiUrl}${this.scholarshipRoute}/user/${user}/student/delete`;
    return this.httpClient.put(
      endpointUrl,
      JSON.stringify(deleteStudentScholarshipData)
    );
  }

  getScholarships(zoneId: number) {
    return this.httpClient
      .get<ScholarshipType[]>(
        `${this.apiUrl}${this.scholarshipRoute}/zoneId/${zoneId}/map`
      )
      .pipe(map((data) => data));
  }

  getScholarshipTypes() {
    const endpointUrl = `${this.apiUrl}${this.scholarshipRoute}/types/map`;
    return this.httpClient.get<ScholarshipTypeMap[]>(endpointUrl)
      .pipe(map((data) => data));
  }
}
